import React, {useEffect, useState} from "react";
import {getById} from "../_request";
import {
    IAxiosGetResponse,
    IServiceDto,
    ITransactionParameterDto,
    ITransactionRouteDto
} from "../../interfaces/IUtilities";
import {useToast} from "../../modules/layout/components/ToastContext";
import {useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import AppBreadcrumb from "../../modules/layout/components/AppBreadcrumb";
import {ParamTypeText, ParamValueTypeText} from "../../helpers/EnumeratorHelper";
import Loader from "../../modules/layout/components/Loader";
import BackButton from "../../modules/layout/components/BackButton";

const TransactionParameterDetails: React.FC = () => {
    const { serviceid, transactionid, id } = useParams();
    const {t} = useTranslation();
    const {showToast} = useToast();
    const [service, setService] = useState({} as IServiceDto);
    const [transactionRoute, setTransactionRoute] = useState({} as ITransactionRouteDto);
    const [transactionParameter, setTransactionParameter] = useState({} as ITransactionParameterDto);
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const pageSize = 10;
    const [sortField, setSortField] = useState("paramType");
    const [asc, setAsc] = useState(true);
    const [loading, setLoading] = useState(true);
    let order = asc ? "asc" : "desc";


    const fetchServiceDetails = async () => {
        try {
            let result = await getById("/api/services/", serviceid!);
            let respStatus = result?.status || result?.response.status;

            if (respStatus === 200) {
                setService(result.data as IServiceDto);
            }
            setLoading(false);

        } catch (error) {
            setLoading(false);
            console.log(t('ConnectionError', {error: String(error)}));
            showToast(t('ConnectionError', {error: String(error)}), 'error');
        }
    }

    const fetchTransactionRoute = async () => {
        try {
            let result = await getById(`/api/transactionroutes/`, transactionid!);

            let respStatus = result?.status || result?.response.status;

            if (respStatus === 200) {
                setTransactionRoute(result.data as ITransactionRouteDto);
            } else {
                throw new Error(t('StatusCode', {code: String(respStatus)}));
            }
        } catch (error) {
            setLoading(false);
            console.log(t('ConnectionError', {error: String(error)}));
        }
    }

    const fetchData = async () => {
        try {
            let result = await getById("/api/transactionparameters/", id!);
            let respStatus = result?.status || result?.response.status;

            if (respStatus === 200) {
                setTransactionParameter(result.data);
                setLoading(false);
            }
            else if (respStatus === 403) {
                navigate("/error/403");
            }
            else if (respStatus === 401) {
                navigate("/auth/login");
            }
            else if (respStatus === 500) {
                navigate("/error/500");
            }
            else {
                throw new Error(t('StatusCode', {code: String(respStatus)}));
            }
        } catch (error) {
            setLoading(false);
            console.log(t('ConnectionError', {error: String(error)}));
            showToast(t('ConnectionError', {error: String(error)}), 'error');
            navigate("/services/list");
        }
    }



    useEffect(() => {
        fetchServiceDetails();
        fetchTransactionRoute();
        fetchData();

    }, [navigate, showToast, page, sortField, asc]);


    return (
        <div className="gg-serviceList container mt-4">
            <AppBreadcrumb
                items={[
                    {title: t('Home'), href: "/"},
                    {title: t('Services'), href: '/services/list'}, // Active page (no href)
                    {title: t('BreadcrumbServiceTransationRoutes', { serviceName: service.name}), href: `/services/${serviceid}/transactions/list`},
                    {title: t('BreadcrumbRouteLabelTransactionParameters', {routeLabel: transactionRoute.routeLabel})} // Active page (no href)
                ]}/>

            <h3 className="mb-3">{t('TransactionParameterDetails')}</h3>

            {loading && (<Loader />)}

            <div className="card">
                <div className="card-header">
                    <h4>{transactionParameter.paramName}</h4>
                </div>
                <div className="card-body">
                    <p><strong>{t('ParameterType')}:</strong> {ParamTypeText[transactionParameter.paramType]}</p>
                    <p><strong>{t('ParameterName')}:</strong> {transactionParameter.paramName}</p>
                    <p><strong>{t('ParameterValue')}:</strong> {transactionParameter.paramValue}</p>
                    <p><strong>{t('ParameterValueType')}:</strong> {ParamValueTypeText[transactionParameter.paramValueType]}</p>
                    <p><strong>{t('InLibEditAllowed')}:</strong>{transactionParameter.isLibEditAllowed ? 'Yes' : 'No'}</p>
                </div>
                <div className="card-footer bg-transparent">
                    <BackButton goTo={`/services/${serviceid}/transactions/${transactionid}/transaction-parameters/list`}/>

                    <button className="btn gg-btn ms-3"
                            onClick={() => navigate(`/services/${serviceid}/transactions/${transactionid}/transaction-parameters/edit/${id}`)}>
                        {t('Edit')}
                    </button>
                </div>
            </div>

        </div>
    )
}
export default TransactionParameterDetails;